import React, { useEffect, useState } from "react";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col, Form } from "react-bootstrap";
import Loading from "../../../components/Loading";
import Accordion from "../../../components/Accordion";
import budgetStyle from "../../Business/styles.module.css";
import styleButton from "../../../components/Button/Button.module.css";
import { useNavigate } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import stylesBusiness from "../../Business/Business.module.css";
import WriteComment from "../../../components/Comments/WriteComment";
import api from "../../../services/api";
import { toast } from "react-toastify";
import CommentSingle from "../../../components/Comments/Single";
import { useOutletContext } from "react-router-dom";
import useFormat from "../../../hooks/utils/useFormat";
import ActivityLogs from "../../../components/ActivityLogs";

export default function Groups() {
  const navigate = useNavigate();
  const { commercial, reload, setreload } = useOutletContext();
  const { formatDate } = useFormat();

  useEffect(() => {
    if (commercial) {
      if (!commercial.is_class) {
        navigate(`/business/feed/${commercial.id}`);
      }
    }
  }, [commercial]);

  const { config, setbreadcrumb, me, token } = useWrapper();
  useEffect(() => {
    if (commercial) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial]);

  const [messageItem, setMessageItem] = useState("");
  const [activity, setActivity] = useState([]);
  const handlemessage = event => {
    setMessageItem(event.target.value);
  };

  async function saveMessage() {
    try {
      await api.post(
        "activity",
        {
          message: messageItem,
          user_id: me.id,
          commercial_id: commercial.id,
          type: "msg",
        },
        config,
      );

      setMessageItem("");
      loadActivity(commercial.id);
      toast.success("Comentário salvo com sucesso!");
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }
  async function loadActivity(itemId) {
    setActivity([]);
    const { data: activity_reponse } = await api.get(`activity?commercial_id=${itemId}&paginate=false`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setActivity(activity_reponse);
  }

  useEffect(() => {
    commercial && loadActivity(commercial?.id);
  }, [commercial]);

  return (
    <Main>
      {!!commercial ? (
        <Content noBG="true">
          <Row>
            <Col>
              {!!commercial && (
                <>
                  <SubContent>
                    {commercial.packages_data.packages.length > 0 && (
                      <Row>
                        <Col>
                          <h6 className="mb-2">
                            <b>Pacotes</b>
                          </h6>
                          {commercial.packages_data.packages.map((e, i) => (
                            <Accordion>
                              <Accordion.Item eventKey="open">
                                <Accordion.Header>
                                  <div className="d-flex align-items-center titleAccordion">
                                    <span className="ml-2">
                                      {e.name}
                                      <span className="small-label"> ({e.number_trainees} fomandos)</span>
                                    </span>
                                  </div>
                                  <Accordion.Extras>
                                    <p className="m-0">{formatDate(e.first_event, 7)}</p>
                                  </Accordion.Extras>
                                </Accordion.Header>
                                <Accordion.Body>
                                  {/* <p className="mb-2"><b>Eventos:</b></p> */}
                                  {e.events.map((e2, i2) => (
                                    <div className={i2 > 0 && "mt-2"}>
                                      <div className={budgetStyle.listItem}>
                                        <div>
                                          <span>{e2.name}</span>
                                        </div>
                                        <div>
                                          <span style={{ opacity: 0.5 }}>{formatDate(e2.date_event, 7)}</span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          ))}
                        </Col>
                      </Row>
                    )}
                    {commercial.packages_data.singles.length > 0 && (
                      <Row className="mt-4">
                        <Col>
                          <h6>
                            <b>Avulsos</b>
                          </h6>
                          <Accordion onlyHeader="true">
                            {commercial.packages_data.singles.map((e, i) => (
                              <Accordion.Item eventKey={`avulso-${i}`}>
                                <Accordion.Header
                                  eventKey={`single-${i + 1}`}
                                  noArraw="true"
                                  style={{ paddingRight: "1rem", cursor: "default" }}
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="ml-2">
                                      {e.event.name}
                                      <span className="small-label"> ({e.number_trainees} fomandos)</span>
                                    </span>
                                  </div>
                                  <Accordion.Extras>
                                    <p className="m-0">{formatDate(e.date_event, 7)}</p>
                                  </Accordion.Extras>
                                </Accordion.Header>
                              </Accordion.Item>
                            ))}
                          </Accordion>
                        </Col>
                      </Row>
                    )}
                    <div className="divisor mt-4 mb-3"></div>
                    <Row>
                      <Col>
                        <h6 className="m-0">
                          <b>Início das Solenidades</b>
                        </h6>
                        <p>{formatDate(commercial.first_event, 7)}</p>
                      </Col>
                    </Row>
                    {!!commercial.invites_trainees && (
                      <Row>
                        <Col>
                          <h6 className="m-0">
                            <b>Convites por Formando</b>
                          </h6>
                          <p>{commercial.invites_trainees} unidades</p>
                        </Col>
                      </Row>
                    )}
                    <div className="divisor mt-1 mb-4"></div>
                    <div>
                      <button
                        onClick={() => navigate(`/business/edit/${commercial.id}#is_class`)}
                        type="button"
                        className={`${styleButton.button_mini_ghost} mr-3`}
                      >
                        <span>Editar Dados/Pacotes</span>
                      </button>
                    </div>
                  </SubContent>
                  <SubContent className="mt-4">
                    <ActivityLogs
                      activity={activity}
                      messageItem={messageItem}
                      handlemessage={handlemessage}
                      saveMessage={saveMessage}
                    />
                  </SubContent>
                </>
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
